import { createSlice } from '@reduxjs/toolkit'
import name from './name'

const initialState = {
  user: { detail: undefined, subscription: undefined },
  list: [],
  lastKey: undefined,
  total: 0,
  totalPending: 0,
  userPoolId: undefined
}
// Store
export const content = createSlice({
  name,
  initialState,
  reducers: {
    getUserList: (state, { payload }) => {
      state.list = payload.users
      state.lastKey = payload.lastKey
      state.total = payload.total
    },
    getUserPendingCount: (state, { payload }) => {
      state.totalPending = payload.total
    },
    addUserList: (state, { payload }) => {
      state.list = state.list.concat(payload.users)
      state.lastKey = payload.lastKey
      state.total = payload.total
    },
    setUserDetail: (state, { payload }) => {
      state.user.detail = { ...state.user.detail, ...payload }
    },
    setUserSubscription: (state, { payload }) => {
      state.user.subscription = { ...state.user.subscription, ...payload?.subscription }
    },
    updateUserEnabledInList: (state, { payload: { username, enabled } }) => {
      state.list.find(t => t.username === username).enabled = enabled
    },
    setUserPoolId: (state, { payload }) => {
      state.userPoolId = payload
    },
    setUserRole: (state, { payload }) => {
      state.user.detail.roles[0] = payload
    },
    updateUserDetails: (state, { payload }) => {
      state.user.detail = { ...state.user.detail, ...payload }
      state.list = state.list.map(user => {
        if (user.username === payload.username) {
          return { ...user, ...payload }
        }
        return user
      })
    },
    resetUserList: state => {
      state.list = []
      state.lastKey = undefined
      state.total = 0
    },
    removeUserFromList: (state, { payload }) => {
      state.list = state.list.filter(user => user.username !== payload)
    },
    updateUserPermissionsInList: (state, { payload: { username, updatedFeatures } }) => {
      state.list.find(t => t.username === username).profile.features = updatedFeatures
    },
    resetUserDetails: state => {
      state.user = initialState.user
    }
  }
})

export const {
  getUserList,
  getUserPendingCount,
  addUserList,
  updateUserEnabledInList,
  setUserDetail,
  updateUserDetails,
  setUserPoolId,
  setUserRole,
  resetUserList,
  resetUserDetails,
  removeUserFromList,
  setUserSubscription,
  updateUserPermissionsInList
} = content.actions

export default content.reducer
